import { render, staticRenderFns } from "./tradeDetailDetailModal.vue?vue&type=template&id=1cdd9bf9&scoped=true"
import script from "./tradeDetailDetailModal.vue?vue&type=script&lang=js"
export * from "./tradeDetailDetailModal.vue?vue&type=script&lang=js"
import style0 from "./tradeDetailDetailModal.vue?vue&type=style&index=0&id=1cdd9bf9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd9bf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cdd9bf9')) {
      api.createRecord('1cdd9bf9', component.options)
    } else {
      api.reload('1cdd9bf9', component.options)
    }
    module.hot.accept("./tradeDetailDetailModal.vue?vue&type=template&id=1cdd9bf9&scoped=true", function () {
      api.rerender('1cdd9bf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/tradeDetailDetailModal.vue"
export default component.exports